import { render } from "./MyServices.vue?vue&type=template&id=72b641ee&ts=true"
import script from "./MyServices.vue?vue&type=script&lang=ts"
export * from "./MyServices.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__